<script setup>
import {useHelpers} from "@/composables";
import { computed } from "vue";

const props = defineProps(['authUser', 'authMarket', 'amanaMarket', 'authMarketRole', 'marketBaseUrl', 'token']);
const {hasAnyRole} = useHelpers();

const currentRoute = computed(() => {
    // Get the current current url
    return window.location.href;
})
</script>

<template>
    <div id="sidebar-scroll" style="height: 100%;" data-simplebar="true">

        <div class="sidebar-header">
            <div>
                <h4 class="logo-text">
                    Amana Market
                </h4>
            </div>
            <div class="toggle-icon ms-auto">
                <i class="bx bx-arrow-to-left" />
            </div>
        </div>
        <!--navigation-->

        <ul v-if="authUser.is_admin && authMarket?.id === (amanaMarket?.id ?? 1)" id="menu" class="metismenu">
            <template v-if="hasAnyRole(['communications','super-admin', 'call-center-team', 'call-center-team-lead', 'supervisor', 'account-manager', 'sales-officer'])">
                <li class="menu-label">Home</li>
                <li>
                    <a id="callcenterusercompliance" href="/four/admin">
                        <div class="parent-icon">
                            <i class="fa-thin fa-sm fa-home"></i>
                        </div>
                        <div class="menu-title">Dashboard</div>
                    </a>
                </li>
                <template v-if="hasAnyRole(['communications','super-admin', 'call-center-team', 'call-center-team-lead', 'supervisor'])">
                    <li>
                        <a href="/four/market-capacity">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-chart-bar"></i>
                            </div>
                            <div class="menu-title">Market Capacity</div>
                        </a>
                    </li>
                    <!-- <li>
                        <a href="/four/metrics">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-shield-alt"></i>
                            </div>
                            <div class="menu-title">Metrics</div>
                        </a>
                    </li> -->
                </template>

                <template v-if="hasAnyRole(['communications','super-admin', 'call-center-team', 'call-center-team-lead', 'supervisor'])">
                    <li class="menu-label">Communications</li>
                    <li>
                        <a href="/four/admin/orders">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-cart-circle-check"></i>
                            </div>
                            <div class="menu-title">Orders</div>
                        </a>
                    </li>
                    <li>
                        <a id="callcenterusercompliance" href="/four/admin/communications/compliance">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-scale-balanced"></i>
                            </div>
                            <div class="menu-title">User Compliance</div>
                        </a>
                    </li>
                    <li>
                        <a href="/four/admin/call-to-transact">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-headset"></i>
                            </div>
                            <div class="menu-title">Call-to-transact</div>
                        </a>
                    </li>
                    <li>
                        <a href="/four/admin/cc-verification">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-headset"></i>
                            </div>
                            <div class="menu-title">CC Verification</div>
                        </a>
                    </li>
                    <li>
                        <a href="/four/admin/risk-outreach">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-mouse-pointer" style="transform: rotate(251deg)"></i>
                            </div>
                            <div class="menu-title">Risk Outreach</div>
                        </a>
                    </li>
                    <li>
                        <a href="https://insights.coamana.com/" target="_blank">
                            <div class="parent-icon">
                                <i class="fa-thin fa-message-sms"></i>
                            </div>
                            <div class="menu-title">SMS System</div>
                        </a>
                    </li>
                </template>

            </template>
            <template v-if="hasAnyRole(['super-admin', 'staff', 'finance', 'call-center-team-lead'])">
                <li class="menu-label">Staff</li>
                <!--<li>
                    <a href="/four/admin/mpesa">
                        <div class="parent-icon">
                            <i class="fa-thin fa-sm fa-cart-circle-check"></i>
                        </div>
                        <div class="menu-title">M-PESA</div>
                    </a>
                </li>-->
                <li>
                    <a href="/four/admin/markets">
                        <div class="parent-icon">
                            <i class="fa-thin fa-sm fa-shop"></i>
                        </div>
                        <div class="menu-title">Markets</div>
                    </a>
                </li>
                <li>
                    <a href="/four/admin/markets/subscriptions">
                        <div class="parent-icon">
                            <i class="fa-thin fa-sm fa-money-check-dollar"></i>
                        </div>
                        <div class="menu-title">Subscriptions</div>
                    </a>
                </li>
                <li>
                    <a href="/four/market/auditlogs">
                        <div class="parent-icon">
                            <i class="fa-thin fa-sm fa-shield-check"></i>
                        </div>
                        <div class="menu-title">Audit Logs</div>
                    </a>
                </li>
                <li>
                    <a href="/four/admin/users">
                        <div class="parent-icon">
                            <i class="fa-thin fa-sm fa-users"></i>
                        </div>
                        <div class="menu-title">Users</div>
                    </a>
                </li>
                <li>
                    <a href="/four/admin/markets/staff">
                        <div class="parent-icon">
                            <i class="fa-thin fa-sm fa-users-rays"></i>
                        </div>
                        <div class="menu-title">Staff Markets</div>
                    </a>
                </li>
            </template>
            <template v-if="hasAnyRole(['staff','super-admin','finance','supervisor', 'sales-officer', 'sales-manager', 'account-manager', 'compliance'])">
                <li class="menu-label">Field</li>
                <template v-if="hasAnyRole(['super-admin', 'sales-officer', 'sales-manager'])">
                    <li>
                        <a href="/four/admin/market-lead">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-shop"></i>
                            </div>
                            <div class="menu-title">Lead Generation</div>
                        </a>
                    </li>
                </template>
                <template v-if="hasAnyRole(['super-admin', 'account-manager'])">
                    <li>
                        <a href="#">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-users"></i>
                            </div>
                            <div class="menu-title">Account Manager</div>
                        </a>
                    </li>
                </template>
                <template v-if="hasAnyRole(['super-admin', 'compliance'])">
                    <li>
                        <a href="/four/admin/finance/market-compliance">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-user-check"></i>
                            </div>
                            <div class="menu-title">Market Compliance</div>
                        </a>
                    </li>
                </template>
            </template>
            <template v-if="hasAnyRole(['finance','super-admin', 'call-center-team', 'call-center-team-lead'])">
                <li class="menu-label">Finance</li>
                <template v-if="hasAnyRole(['finance','super-admin'])">
                    <li>
                        <a href="/four/admin/finance/orders">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-cart-circle-check"></i>
                            </div>
                            <div class="menu-title">Orders</div>
                        </a>
                    </li>
                    <li>
                        <a href="/four/admin/credit-queue">
                            <div class="parent-icon">
                                <i class="fa-thin fa-id-card"></i>
                            </div>
                            <div class="menu-title">Credit Queue</div>
                        </a>
                    </li>
                    <li>
                        <a id="earnings" href="/four/admin/finance/earnings">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-cart-circle-check"></i>
                            </div>
                            <div class="menu-title">Earnings</div>
                        </a>
                    </li>
                    <li>
                        <a href="/four/admin/finance/insurance">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-shield-alt"></i>
                            </div>
                            <div class="menu-title">Insurance</div>
                        </a>
                    </li>
                    <li>
                        <a href="/four/admin/finance/loanbook">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-coins"></i>
                            </div>
                            <div class="menu-title">LoanBook</div>
                        </a>
                    </li>
                    <li>
                        <a href="/four/admin/finance/defaulters">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-file-invoice-dollar"></i>
                            </div>
                            <div class="menu-title">OverDue</div>
                        </a>
                    </li>
                    <li>
                        <a href="/four/admin/finance/payouts">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-cash-register"></i>
                            </div>
                            <div class="menu-title">Payouts</div>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:" class="has-arrow">
                            <div class="parent-icon"><i class="fa-thin fa-sm fa-university"></i>
                            </div>
                            <div class="menu-title">VBank Accounts</div>
                        </a>
                        <ul>
                            <li>
                                <a href="/four/admin/finance/bank-accounts">
                                    <i class="fa-thin fa-sm fa-list"></i>
                                    Accounts
                                </a>
                            </li>
                            <li>
                                <a href="/four/admin/finance/bank-transactions">
                                    <i class="fa-thin fa-sm fa-exchange"></i>
                                    Transactions
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a href="javascript:" class="has-arrow">
                            <div class="parent-icon"><i class="fa-thin fa-sm fa-money-simple-from-bracket"></i>
                            </div>
                            <div class="menu-title">Requests</div>
                        </a>
                        <ul>
                            <li>
                                <a href="/four/admin/finance/withdrawal-requests">
                                    <i class="fa-thin fa-square-minus"></i>
                                    Withdrawal
                                </a>
                            </li>
                            <li>
                                <a href="/four/admin/finance/pos-applications">
                                    <i class="fa-thin fa-sm fa-list"></i>
                                    POS
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a href="/four/admin/finance/market-fees">
                            <div class="parent-icon">
                                <i class="fa-thin fa-money-bill-wave"></i>
                            </div>
                            <div class="menu-title">Market Fees</div>
                        </a>
                    </li>
                </template>
                <li>
                    <a href="javascript:" class="has-arrow">
                        <div class="parent-icon"><i class="fa-thin fa-sm fa fa-lock"></i>
                        </div>
                        <div class="menu-title">Verifications</div>
                    </a>
                    <ul>
                        <li>
                            <a href="/four/admin/finance/users">
                                <i class='bx bx-radio-circle'></i>
                                <div class="menu-title">User Verification</div>
                            </a>
                        </li>
                        <li>
                            <a href="/four/admin/finance/market-compliance">
                                <i class='bx bx-radio-circle'></i>
                                <div class="menu-title">Market Verification</div>
                            </a>
                        </li>
                        <li>
                            <a href="/four/admin/finance/id-verifications">
                                <i class='bx bx-radio-circle'></i>
                                <div class="menu-title">BVN/NIN Verifications</div>
                            </a>
                        </li>
                    </ul>
                </li>
                <template v-if="hasAnyRole(['finance','super-admin'])">
                    <li>
                        <a href="/four/admin/finance/subscriptions">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-bell"></i>
                            </div>
                            <div class="menu-title">Subscriptions</div>
                        </a>
                    </li>
                    <li>
                        <a href="/four/admin/finance/settings">
                            <div class="parent-icon">
                                <i class="fa-thin fa-sm fa-cog"></i>
                            </div>
                            <div class="menu-title">Settings</div>
                        </a>
                    </li>
                </template>
            </template>
            <!-- <li class="menu-label">Data</li>
            <li>
                <a href="/four/admin/data/cleanup">
                    <div class="parent-icon">
                        <i class="fa-thin fa-sm fa-broom"></i>
                    </div>
                    <div class="menu-title">Clean Up</div>
                </a>
            </li>
            <li>
                <a href="/four/admin/data/qa">
                    <div class="parent-icon">
                        <i class="fa-thin fa-sm fa-clipboard-check"></i>
                    </div>
                    <div class="menu-title">QA</div>
                </a>
            </li>
            <li>
                <a href="/four/admin/data/risk-flags">
                    <div class="parent-icon">
                        <i class="fa-thin fa-id-card"></i>
                    </div>
                    <div class="menu-title">Risks & KYC</div>
                </a>
            </li>
            <li>
                <a href="/four/admin/data/pipeline-gaps">
                    <div class="parent-icon">
                        <i class="fa-thin fa-sm fa-chart-line-down"></i>
                    </div>
                    <div class="menu-title">Pipeline Gaps</div>
                </a>
            </li> -->
            <template v-if="hasAnyRole(['super-admin'])">
                <li class="menu-label">Reports</li>
                <li>
                    <a href="javascript:" class="has-arrow">
                        <div class="parent-icon"><i class="bx bx-category"></i>
                        </div>
                        <div class="menu-title">Reports</div>
                    </a>
                    <ul>
                        <li>
                            <a href="/four/market/reports/verifications">
                                <i class='bx bx-radio-circle'></i>
                                <div class="menu-title">Communications Verifications</div>
                            </a>
                        </li>
                        <li>
                            <a href="/four/admin/finance/reports/verifications">
                                <i class='bx bx-radio-circle'></i>
                                <div class="menu-title">Finance Verifications</div>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="menu-label">Super Admin</li>
                <li>
                    <a href="/four/admin/rbac">
                        <div class="parent-icon">
                            <i class="fa-thin fa-sm fa-cog"></i>
                        </div>
                        <div class="menu-title">RBAC</div>
                    </a>
                </li>
                <li>
                    <a href="/four/admin/adminusers">
                        <div class="parent-icon">
                            <i class="fa-thin fa-sm fa-cog"></i>
                        </div>
                        <div class="menu-title">Admin Users</div>
                    </a>
                </li>
            </template>
        </ul>
        <ul v-else id="menu" class="metismenu mm-show">
            <li>
                <a id="myaccount" class="has-arrow" style="background-color: #283342;" href="javascript:">
                    <div class="menu-title" style="color: white;">{{ authUser.first_name }}'s Account
                    </div>
                </a>
                <ul v-if="['enterprise-owner', 'enterprise-admin'].includes(authMarketRole)">
                    <li>
                        <a id="yourprofile" href="/four/profile">
                            <div class="menu-title">Account Settings</div>
                        </a>
                    </li>
                </ul>
                <ul v-else>
                    <li>
                        <a href="/four">
                            <div class="menu-title">Orders & Trade</div>
                        </a>
                    </li>
                    <li>
                        <a id="products-and-services-member" href="/four/pay-fees">
                            <div class="menu-title">Fees</div>
                        </a>
                    </li>
                    <li>
                        <a id="products-and-services-member" href="/four/products">
                            <div class="menu-title">Inventory & Listings</div>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:;" class="has-arrow">
                            <div class="menu-title">Earnings & Transactions</div>
                        </a>
                        <ul>
                            <li>
                                <a href="/four/sales">
                                    <div class="menu-title">Earnings</div>
                                </a>
                            </li>
                            <li>
                                <a href="/four/earnings">
                                    <div class="menu-title">Transactions</div>
                                </a>
                            </li>
                            <li>
                                <a href="/four/my-profile?referral_program=true">
                                  <div class="menu-title">Referral Program</div>
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a id="yourprofile" href="/four/loans">
                          <div class="menu-title">Loans</div>
                        </a>
                      </li>
                    <li>
                        <a id="yourprofile" href="/four/profile">
                            <div class="menu-title">Account Settings</div>
                        </a>
                    </li>
                    <!-- <li> -->
                    <!--     <a href="incidences" disabled style="color: #EBEBE4 !important;"> -->
                    <!--         <div class="menu-title"> -->
                    <!--             Incidences -->
                    <!--         </div> -->
                    <!--     </a> -->
                    <!-- </li> -->
                </ul>
            </li>
            <li v-if="['enterprise-owner', 'enterprise-admin'].includes(authMarketRole)" class="mm-active">
                <a id="myaccount" class="has-arrow" style="background-color: #283342;" href="javascript:">
                    <div class="menu-title" style="color: white;">{{ authMarket?.name }}</div>
                </a>
                <ul id="enterprise">
                    <li>
                        <a id="manage_market" href="/four/enterprise/markets" :class="currentRoute.includes('/four/enterprise/markets') ? 'tw-bg-[#0d6efd1f] text-success' : ''">
                            <div class="menu-title">
                                Manage Markets
                            </div>
                        </a>
                    </li>
                    <li>
                        <a id="team_and_admin" href="/four/enterprise/team-and-admin">
                            <div class="menu-title">
                                Team  Management
                            </div>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:;" class="has-arrow">
                            <div class="menu-title">Fees and Charges</div>
                        </a>
                        <ul>
                            <li>
                                <a href="/four/enterprise/fees">
                                    <div class="menu-title">Manage Fees</div>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
                
            </li>
            <li v-else-if="['market-leader', 'market-admin', 'market-agent'].includes(authMarketRole)" class="mm-active">
                <a id="myaccount" class="has-arrow" style="background-color: #283342;" href="javascript:">
                    <div class="menu-title" style="color: white;">{{ authMarket?.name }}
                    </div>
                </a>
                <ul id="market">
                    <template v-if="authUser.verification_status !== 'blacklisted'">
                        <template v-if="authMarketRole !== 'market-agent'">
                            <li>
                                <a id="marketprofile" href="/four/market/profile">
                                    <div class="menu-title">Account Settings</div>
                                </a>
                            </li>
                            <li>
                                <a :href="`${marketBaseUrl}/dashboard?token=${token}&market_id=${authMarket?.id}`"
                                   target="_blank">
                                    <div class="menu-title">Home Page</div>
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;" class="has-arrow">
                                    <div class="menu-title">Earnings & Transactions</div>
                                </a>
                                <ul>
                                    <li>
                                        <a href="/four/market/wallet-and-payments">
                                            <div class="menu-title">Earnings</div>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/four/market/sales">
                                            <div class="menu-title">Transactions</div>
                                        </a>
                                    </li>
                                  
                                    <li v-if="!authMarket.parent_id">
                                        <a id="charges-rent-fees-and-taxes"
                                           href="/four/market/charges-rent-fees-and-taxes">
                                            <div class="menu-title">Fees and Charges</div>
                                        </a>
                                    </li>
                                    <li>
                                        <a id="charges-rent-fees-and-taxes" href="/four/market/pending-payments">
                                            <div class="menu-title">Pending Payments</div>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            <li v-if="authMarket.parent_id">
                                <a href="javascript:;" class="has-arrow">
                                    <div class="menu-title">Fees & Charges</div>
                                </a>
                                <ul>
                                    <li>
                                        <a href="/four/market/fees">
                                            <div class="menu-title">Manage Fees</div>
                                        </a>
                                    </li>
                                     <li>
                                        <a href="/four/market/charges">
                                            <div class="menu-title">Manage Charges</div>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                           
                            <li>
                                <a id="market-product-and-services" href="/four/market/products">
                                    <div class="menu-title">Inventory & Listings</div>
                                </a>
                            </li>
                            <li>
                                <a id="team_and_admin" href="/four/market/team-and-admin">
                                    <div class="menu-title">
                                        Team  Management
                                    </div>
                                </a>
                            </li>
                        </template>
                        <li>
                            <a id="market-members" href="/four/market/members">
                                <div class="menu-title">Agents, Suppliers, Buyers & Farmers</div>
                            </a>
                        </li>
                        <li v-if="authMarketRole !== 'market-agent'">
                            <a href="/four/org-privacy">
                                <div class="menu-title">Org Privacy</div>
                            </a>
                        </li>
                    </template>
                </ul>
            </li>
        </ul>
    </div>
</template>

<style scoped></style>
